import { appendALExamTemplate } from '@/functions/idp'

import RIC from './RIC_7'

export default appendALExamTemplate({
  ...RIC,
  aimName: 'A-level'
})
